module.exports = __webpack_public_path__ + "static/media/waterDrop.c9d2e40d.png";